module.exports = __webpack_public_path__ + "static/media/jira_final_notification_setup.dfc13073.jpeg";